import { getLuminance } from 'polished';

var getTextColor = function getTextColor(props) {
  if (props.color) {
    return props.color;
  }

  if (getLuminance(props.backgroundColor) <= 0.5) return '#fff';
  return '#000';
};

var getTextSize = function getTextSize(props) {
  if (props.fontSize) {
    return props.fontSize;
  }

  return props.height / 2.5 + "px";
};

var getPadding = function getPadding(props) {
  return 0.001 * props.height + "px " + props.height / 2 + "px";
};

var getSizeComparedToBase = function getSizeComparedToBase(props, originalValue) {
  return props.height * originalValue / 64;
};

export { getPadding, getSizeComparedToBase, getTextColor, getTextSize };